/* Moves the Shopify Forms popup teaser ("20% off your first order") on phones.

   Why: the teaser is a fixed tab at the bottom-left of the viewport and covers
   the sticky Add-to-cart bar and the main buttons. Its position is a native
   select in the Forms admin, which cannot be driven reliably, so it is done
   here (Tim, 20 Oct: "fix it").

   How: <shopify-forms-embed> has an OPEN shadow root, and the Forms app sets the
   position with INLINE styles on #app-embed (left:0; right:unset; bottom:0). An
   !important rule beats an inline style, so one adopted stylesheet is enough.
   Only the teaser step is moved (data-current-step="tease"); the popup itself is
   left alone. Phones only (max-width 749px), bottom right, clear of the home
   indicator, and lifted above the sticky buy bar on the product page.

   The embed is created late (after the popup delay), so watch for it. Stops after
   a minute; the sheet is adopted, so it survives the app re-rendering. */
(function () {
  var CSS =
    '@media (max-width: 749px) {' +
    '#app-embed[data-current-step="tease"] {' +
    'left: auto !important;' +
    'right: max(8px, env(safe-area-inset-right)) !important;' +
    'bottom: calc(8px + env(safe-area-inset-bottom) + var(--unc-teaser-lift, 0px)) !important;' +
    'padding: 10px 12px !important;' +
    '}}';

  function apply(host) {
    var sr = host.shadowRoot;
    if (!sr || host.__uncTeaser) return !!host.__uncTeaser;
    try {
      var sheet = new CSSStyleSheet();
      sheet.replaceSync(CSS);
      sr.adoptedStyleSheets = sr.adoptedStyleSheets.concat(sheet);
    } catch (e) {
      var s = document.createElement('style');
      s.textContent = CSS;
      sr.appendChild(s);
    }
    /* The product page has a sticky Add-to-cart bar (about 65px) at the bottom.
       27 Oct (audit): on phones the tab still landed on top of the buy box text and the
       bar, so on the product page it is not shown below 750px (the 20% popup is still
       offered on every other page and on desktop). */
    if (document.querySelector('unc-sticky-cta')) {
      host.style.setProperty('--unc-teaser-lift', '72px');
      try {
        var hide = new CSSStyleSheet();
        hide.replaceSync('@media (max-width: 749px) { #app-embed[data-current-step="tease"] { display: none !important; } }');
        sr.adoptedStyleSheets = sr.adoptedStyleSheets.concat(hide);
      } catch (e) {}
    }
    host.__uncTeaser = true;
    return true;
  }

  var tries = 0;
  var timer = setInterval(function () {
    var host = document.querySelector('shopify-forms-embed');
    if ((host && apply(host)) || ++tries > 120) clearInterval(timer);
  }, 500);
})();
